import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { color } from "src/styles/variables";
import FaqItem from "./faq-item";

function Faqs({ faqs = [], title, id }) {
  return (
    <FaqsWrapper>
      {title && <H3 data-selector="Faqs-title">{title}</H3>}
      {faqs.map((faq, index) => (
        <FaqItem
          key={`FaqItem-${id}-${index}`}
          id={`FaqItem-${id}-${index}`}
          subtitle={faq.subtitle}
          content={faq.content}
        />
      ))}
    </FaqsWrapper>
  );
}

export default Faqs;

Faqs.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  faqs: PropTypes.arrayOf(
    PropTypes.shape({
      subtitle: PropTypes.string,
      content: PropTypes.string,
    })
  ),
};

const FaqsWrapper = styled.section`
  margin-bottom: 30px;
`;

const H3 = styled.h3`
  font-size: 20px;
  margin-bottom: 15px;
  font-weight: 800;
  color: ${color.grey};
`;
